import React, { useState , useEffect} from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'



const FinishAccount = () => {
    const search = window.location.search;
    const paramss = new URLSearchParams(search);
  //  console.log(paramss.get('guid'))
    const history = useHistory();

    const [error, setError] = useState(false)
    const [tlfNumber, setTlfNumber] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [passwordError, setPasswordError] = useState("");
    const [passwordRepeatError, setPasswordRepeatError] = useState("");
    const [emptyName, setEmptyName] = useState()
    const [emptyNumber, setEmptyNumber] = useState()
    const [emptyPassword, setEmptyPassword] = useState()
    const [noPasswordMatch, setNoPasswordMatch] = useState()
    const isValidName = /^[a-z ,.'-]+$/i

    const [nameError, setNameError] = useState('')
    const [numberError, setNumberError] = useState('')

    const validateName = (e) => {
        if (e.target?.value && e.target.value.match(isValidName)) {
            setName(e.target.value)

        }
    }

    const handleNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setTlfNumber(value);
        setNumberError('')
    };

    const handleNameChange = (e) => {
        validateName(e)
        setName(e.target.value)
       // setError(false)
        setNameError('')
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
        setPasswordError('')
    }

    const handleRepeatPasswordChange = (e) => {
        setPasswordRepeat(e.target.value)
        setPasswordRepeatError('')
    }

   function handleSubmit ()  {
       
      
        if (name === '' || tlfNumber === '' || password === '' || passwordRepeat === '') {
            setError(true)
        }
        if (password.length && passwordRepeat.length && password !== passwordRepeat) {
            setError(true)
            setNoPasswordMatch('adgangskode matcher ikke')
            
       }
       if (password.length && passwordRepeat.length && password === passwordRepeat) {
           setNoPasswordMatch('')
           setError(false)
       }
        if (name === '') {

            setNameError('udfyld venligst navn')
        }
        if (tlfNumber === '') {
            setNumberError('udfyld venligst telefonnummer')
        }
        if (password === '') {
            setPasswordError('udfyld venligst adgangskode')
        }
        if (password.length && passwordRepeat === '') {
            setPasswordRepeatError('udfyld veligst adgangskode igen')
        }
        if (name.length && !name.match(isValidName)) {
            setNameError('kun bogstav i navnet')
        }
       
        if (tlfNumber !== '' && tlfNumber.length !== 8) {
            setNumberError('nummeret er forkert')
        }
       
        else if (name.length && name.match(isValidName) && tlfNumber.length === 8) {  // name/tlf varified and password at both places matches
          
            let email = paramss.get('email')
            let uid = paramss.get('guid')

          //  console.log(`http://dev.ebillet.dk/systemnative/customer.asmx/Create?Email=${email}&Password=${password}&Name=${name}&Phone=${tlfNumber}&guid=${uid}`)
            fetch(`http://dev.ebillet.dk/systemnative/customer.asmx/Create?Email=${email}&Password=${password}&Name=${name}&Phone=${tlfNumber}&guid=${uid}`, {
                method: "GET",
            })
                .then((res) => res.json())
                .then(result => {
                    console.log(result, 'result')
                    if (result.result === 1) {
                        history.push('/profile', {
                            login_info: result.login, transaction: result.transactionsPrYear[0], newsgroup: result.Newsgroups, reservations: result.Reservations
                        })
                    }
                })

          
        }
    }

    useEffect(() => {
        if (!nameError.length && !numberError.length && !passwordError && !passwordRepeatError) {
            setError(false)
        }
    }, [nameError, numberError, passwordError, passwordRepeatError])

    return (
        <div className='login '> 
            <p className='profile'>Opret profil</p>
            <p className='emailtext'>Indtast dine oplysninger</p>

            {/*<form >*/}
            <div className='loginflow'>
                <label >Email</label>
                <input className='email-input' value={paramss.get('email')}></input>
                <label>Navn</label>
                <input className='email-input' type='text' placeholder='Indtast navn'  onChange={handleNameChange}></input>
                <label>Telefonnummer</label>
                <input className='email-input' maxLength='8' type='text' placeholder='Indtast telefonnummer' onChange={handleNumberChange}  value={tlfNumber}></input>
                <label>Adgangskode</label>
                <input className='password email-input' type='password' onChange={handlePasswordChange}></input>
                <label>Gentag adgangskode</label>
                <input className='email-input' type='password' onChange={handleRepeatPasswordChange}></input>
                <button type="submit" className='send_btn' onClick={handleSubmit}>Gem</button>
            </div>
            {/*</form>*/}
            {error === true ?
                <div className='error-div'> 
                    {nameError && <span>{nameError}</span>}
                    {numberError && <span>{numberError}</span>}
                    {passwordError && <span>{passwordError}</span>}
                    {passwordRepeatError && !passwordError && <span>{passwordRepeatError}</span>}
                    {noPasswordMatch && <span>{noPasswordMatch}</span>}
                </div> : null}
        </div>
    )
}

export default FinishAccount
